import { JSX } from "react/jsx-runtime";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";

interface ConfirmActionModalProps {
  show?: boolean;
  title?: string;
  iconClass?: string;
  iconColor?: string;
  heading?: string;
  description?: string | JSX.Element;
  confirmText?: string;
  cancelText?: string;
  confirmColor?: string;
  confirmDisabled?: boolean;
  onConfirm?: () => void;
  onClose?: () => void;
}

const ConfirmActionModal = ({
  show,
  title,
  iconClass = "bx bxs-badge-check",
  iconColor = "text-success",
  heading = "Are you sure?",
  description,
  confirmText = "Confirm",
  confirmColor = "success",
  cancelText = "Cancel",
  confirmDisabled = false,
  onConfirm,
  onClose,
}: ConfirmActionModalProps) => {
  const renderDescription = () => {
    if (!description) return null;

    if (typeof description === "string") {
      return (
        <p
          className="text-muted mb-4"
          style={{ whiteSpace: "pre-line", textAlign: "left" }}
        >
          {description}
        </p>
      );
    }

    return <div className="text-start text-muted mb-4">{description}</div>;
  };

  return (
    <Modal fade isOpen={show} toggle={onClose} centered>
      {title && <ModalHeader toggle={onClose}>{title}</ModalHeader>}
      <ModalBody className="text-center p-5">
        <i className={`${iconClass} display-4 ${iconColor}`} />
        <div className="mt-4">
          <h4 className="mb-3">{heading}</h4>
          {renderDescription()}
          <div className="hstack gap-2 justify-content-center">
            <Button color="light" onClick={onClose}>
              {cancelText}
            </Button>
            <Button
              color={confirmColor}
              onClick={onConfirm}
              disabled={confirmDisabled}
            >
              {confirmText}
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ConfirmActionModal;
